export interface ISmartEngageBannerStoreState {
  isLoading: boolean;
  data: ISmartEngageData;
}

export interface ISmartEngageData {
  data: {slots: {(key: string): Array<IBannerData>}};
  success: boolean;
}

export interface IBannerData {
  banner_type?: number;
  img_url?: string;
  slug?: string;
  cta_type?: string;
  name?: string;
  cta_url?: string;
  filter?: Object;
}

export const TOGGLE_LOADING_SMART_ENGAGE = 'TOGGLE_LOADING_SMART_ENGAGE';
export const UPDATE_SMART_ENGAGE = 'UPDATE_SMART_ENGAGE';

export interface IToggleLoadingSmartEngage {
  type: typeof TOGGLE_LOADING_SMART_ENGAGE;
  actionData: ISmartEngageBannerStoreState['isLoading'];
}

export interface IUpdateSmartEngageData {
  type: typeof UPDATE_SMART_ENGAGE;
  actionData: ISmartEngageBannerStoreState['data'];
}

export type SmartEngageActionTypes = IToggleLoadingSmartEngage | IUpdateSmartEngageData;
